import {
  RELEVANCE_NAME_TO_SCORE,
  DEFAULT_RELEVANCE_SCORE_FILTER_VALUE,
} from '../../../constants/relevance';
import type { HotjarFilters } from '../../../store/list/types';

type SubQuery = {
  EQUAL: Record<string, number[] | boolean>;
};

export const areRelevanceScoresAllSelected = (scores: string[]): boolean =>
  scores.length === DEFAULT_RELEVANCE_SCORE_FILTER_VALUE.length;

export function getRelevanceScoreSubQuery(hotjarFilters: HotjarFilters): SubQuery | null {
  const { relevanceScore } = hotjarFilters;

  if (!relevanceScore || areRelevanceScoresAllSelected(relevanceScore)) {
    return null;
  }

  const relevanceScoreSubQuery = {
    EQUAL: {
      relevance_score: hotjarFilters.relevanceScore.reduce(
        (acc, relevanceName) => acc.concat(RELEVANCE_NAME_TO_SCORE[relevanceName]),
        [] as number[],
      ),
    },
  };

  return relevanceScoreSubQuery;
}
